module.exports = [{
      plugin: require('/opt/buildhome/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ethereum.world","short_name":"Eth.wrl","start_url":"/","icon":"src/images/favicon.png"},
    }]
